import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Input,
  Button
} from "reactstrap";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import CommonTable from "../../../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import { CertificateTableHeader } from "../../../../Data/Tables/ReactstrapTables/BasicTables";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl } from "../../../../Utils/Baseurl/Baseurl";
import { Btn } from "../../../../AbstractElements";
import { toast } from "react-toastify";


type Certificate = {
  gmpcertificate?: { path: string; filestatus: string };
  analysiscertificate?: { path: string; filestatus: string };
  quotation?: { path: string; filestatus: string };
  productpackagecoverorinsert?: { path: string; filestatus: string };
  batchtestingreport?: { path: string; filestatus: string };
  otherdocuments?: { path: string; filestatus: string };
};
interface OtherDetail {
  path: string;
  filename: string;
}
interface CertificateData {
  path: string;
  filename: string;
  filestatus: string;
}

interface Token {
  id: string;
  tokenid?: string;
  medicinename?: string;
  finalstatus?: number;
  quotationno?: string;
  purchaserate?: string;
  certificates?: {
    quotation: string;
  };
  appointmentdate: string;
  tokenno: string;
  medicalrep?: {
    name: string;
    Company?: {
      companyname: string;
    };
  };
  tokenregistration?: {
    tokenno: string;
    prefix: string;
    appointmentdate: string;
  };
}

const AllCertificates = () => {
  const navigate = useNavigate();
  const { tokenid } = useParams();
  const [certificateData, setCertificateData] = useState<CertificateData[]>([]);
  // State for modals
  const [approvalModalOpen, setApprovalModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  // Other state variables
  const [indentForm, setIndentForm] = useState<string | null>(null);
  const [medicinename, setMedicineName] = useState("");
  const [quotation, setQuotation] = useState("");
  const [purchaserate, setPurchaserate] = useState("");
  const [chemical, setChemical] = useState("");
  const [mrp, setMrp] = useState("");
  const [otherDetails, setOtherDetails] = useState<OtherDetail[]>([]);
  const [description, setDescription] = useState("");
  const [rejections, setRejections] = useState("");
  const [finalstatus, setFinalStatus] = useState("");
  const [status, setStatus] = useState("");
  const [contents, setContents] = useState<any[]>([]);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionstatus, setRejectionStatus] = useState("");
  const [rejectionReasons, setRejectionReasons] = useState<any[]>([]);
  const [tokens, setTokens] = useState<Token[]>([]);
  const [purchaseTeamName, setPurchaseTeamName] = useState("");

  const fetchCertificates = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}medicinedetails/certificates/${tokenid}`
      );
      console.log(response.data);
      setCertificateData(response.data.certificates);
      setMedicineName(response.data.medicinename);
      setQuotation(response.data.quotationno);
      setPurchaserate(response.data.purchaserate);
      setChemical(response.data.chemical);
      setMrp(response.data.mrp);
      setDescription(response.data.description);
      setIndentForm(response.data.indentform);
      setRejections(response.data.rejectionstatus);
      setStatus(response.data.status);
      setFinalStatus(response.data.finalstatus);
      setContents(response.data?.contents || []);
      setOtherDetails(response.data?.otherdetails || []);
      setPurchaseTeamName(response.data.purchaseTeam );

      setRejectionReasons(
        Array.isArray(response.data?.rejectionDetails)
          ? response.data.rejectionDetails
          : []
      );
      setRejectionStatus(response.data?.rejectstatus || "");
    } catch (error) {
      console.error("Error fetching certificates:", error);
    }
  };

  useEffect(() => {
    if (tokenid) {
      fetchCertificates();
    }
  }, [tokenid]);

  // Open the approval confirmation modal
  const handleApprove = () => {
    setApprovalModalOpen(true);
  };

  // When user confirms approval in the modal, this function executes the approval logic.
  const confirmApproval = async () => {
    setApprovalModalOpen(false);
    try {
      if (!tokenid) {
        console.error("Token ID is missing");
        return;
      }
      await axios.post(`${baseUrl}medicinedetails/finalapproval/${tokenid}`, {
        finalstatus: 1,
      });
      toast.success("Certificate Approved Successfully");
      setTimeout(
        () => navigate(`${process.env.PUBLIC_URL}/finalverification`),
        2000
      );
      fetchCertificates();
    } catch (error) {
      console.error("Error approving certificate:", error);
    }
  };

  const handleReject = () => {
    setModalOpen(true);
  };
  const handleCertificateApproval = async (certificateKey: string) => {
    if (!tokenid) return;
    try {
      await axios.post(`${baseUrl}medicinedetails/approve-certificate`, { tokenid, certificateKey, filestatus:"3" });
      toast.success(`${certificateLabels[certificateKey] || certificateKey} Approved Successfully`);
      fetchCertificates(); // Refresh data after approval
    } catch (error) {
      console.error("Error approving certificate:", error);
      toast.error("Approval failed");
    }
  };
  const handleCertificateRejection = async (certificateKey: string) => {
    if (!tokenid) return;
    try {
      await axios.post(`${baseUrl}medicinedetails/reject-certificate`, { tokenid, certificateKey });
      toast.success(`${certificateLabels[certificateKey] || certificateKey} Rejected Successfully`);
      fetchCertificates(); // Refresh data after rejection
    } catch (error) {
      console.error("Error rejecting certificate:", error);
      toast.error("Rejection failed");
    }
  };

  const submitRejection = async () => {
    try {
      await axios.post(`${baseUrl}medicinedetails/finalapproval/${tokenid}`, {
        finalstatus: 2,
        rejectionstatus: rejectionReason,
      });
      toast.success("Certificate Rejected Successfully");
      setModalOpen(false);
      setTimeout(
        () => navigate(`${process.env.PUBLIC_URL}/finalverification`),
        2000
      );
    } catch (error) {
      console.error("Error rejecting certificate:", error);
    }
  };

  const certificateLabels: { [key: string]: string } = {
    gmpcertificate: "GMP Certificate",
    analysiscertificate: "Analysis Certificate",
    quotation: "Quotation",
    productpackagecoverorinsert: "Product Package Cover/Insert",
    batchtestingreport: "Batch Testing Report",
    otherdocuments: "Other Documents",
  };

  
  const allCertificatesApproved =
    certificateData &&
    Object.keys(certificateData).length > 0 &&
    Object.values(certificateData).every((file) => file.filestatus === "3");

  return (
    <>
      <Col sm={12}>
        <Card>
          <CommonCardHeader title="Medicine Details" />
          <div className="table-responsive">
            <Card className="p-3 ps-5 bg-light text-dark mx-5">
              {/* Medicine Name */}
              <Row className="padding">
                <Col md={2} className="fw-bold text-start">
                  Medicine Name
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {medicinename}
                </Col>
                <Col md={2} className="fw-bold text-start">
                  Quantity
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {quotation}
                </Col>
              </Row>
              {/* Description */}
              <Row className="padding">
                <Col md={2} className="fw-bold text-start">
                  Description
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp;{description}
                </Col>
                <Col md={2} className="fw-bold text-start">
                  Purchase Rate
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp;{purchaserate}
                </Col>
              </Row>
              {/* Contents */}
              <Row className="padding">
                <Col md={2} className="fw-bold text-start">
                  Contents in gm
                </Col>
                <Col md={4} className="text-start">
                  {Array.isArray(contents) && contents.length > 0 ? (
                    <ul className="m-0 p-0">
                      {contents.map((item, index) => (
                        <li key={index}>
                          <Row>
                            <Col md={6} className="text-start">
                              :&nbsp;&nbsp;&nbsp;&nbsp;{item.name}
                            </Col>
                            <Col md={6} className="text-start">
                              -&nbsp;&nbsp;{item.quantity}gm
                            </Col>
                           
                          </Row>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <span>{contents || "No contents available"}</span>
                  )}
                </Col>
                {/* <Col md={2} className="fw-bold text-start">
                  Chemical
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {chemical}
                </Col> */}
                  <Col md={2} className="fw-bold text-start">
                 MRP
                </Col>
                <Col md={4} className="text-start">
                  :&nbsp;&nbsp;&nbsp;&nbsp; {mrp}
                </Col>
              </Row>
            
            </Card>
          </div>

         <div className="table-responsive">
                    <CommonTable headData={CertificateTableHeader}>
                      {certificateData ? (
                        <>
                          {Object.entries(certificateData).map(([key, file], index) => (
                            <tr key={index}>
                              <th scope="row">{index + 1}</th>
                              <td>{certificateLabels[key] || key}</td>
                              <td>
                                <a href={`${baseUrl}${file.path}`} target="_blank" rel="noopener noreferrer">
                                {file.filename}  
                                </a>
                              </td>
                              <td>
                                {(file.filestatus === "1" || file.filestatus === "0") ? (
                                  <>
                                    <Button color="success" size="sm" className="me-2" onClick={() => handleCertificateApproval(key)}>
                                      Approve
                                    </Button>
                                    <Button color="danger" size="sm" onClick={() => handleCertificateRejection(key)}>
                                      Reject
                                    </Button>
                                  </>
                                ) : file.filestatus === "3" ? (
                                  <span className="text-success fw-bold">Approved</span>
                                ) : (
                                  <span className="text-danger fw-bold">Rejected</span>
                                )}
                              </td>
                            </tr>
                          ))}
        
                          {indentForm && (
                            <tr>
                              <th scope="row">{Object.keys(certificateData).length + 1}</th>
                              <td>Indent Form</td>
                              <td>
                                <a href={`${baseUrl}${indentForm}`} target="_blank" rel="noopener noreferrer">
                                  View Indent Form
                                </a>
                              </td>
                            </tr>
                          )}
        
                          {otherDetails.length > 0 && (
                            <>
                              <tr>
                                <th colSpan={3} className="text-center fw-bold fs-6">Supporting Documents</th>
                              </tr>
                              {otherDetails.map((file, index) => (
                                <tr key={index}>
                                  <th scope="row">{Object.keys(certificateData).length + 2 + index}</th>
                                  <td>Document {index + 1}</td>
                                  <td>
                                    <a href={`${baseUrl}${file.path}`} target="_blank" rel="noopener noreferrer">
                                      {file.filename}
                                    </a>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
        
                        </>
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            No certificates available
                          </td>
                        </tr>
                      )}
                    </CommonTable>
                  </div>
        
          {/* Rejection Reasons */}
          {Array.isArray(rejectionReasons) &&
            rejectionReasons.filter(
              (reason) =>
                reason.rejectstatus && reason.rejectstatus.trim()
            ).length > 0 && (
              <div className="mt-3 p-3 bg-light border rounded m-5">
                <strong className="text-primary">
                  Rejection Reasons:
                </strong>
                <ul className="m-0 p-0">
                  {rejectionReasons
                    .filter(
                      (reason) =>
                        reason.rejectstatus && reason.rejectstatus.trim()
                    )
                    .map((reason, index) => (
                      <li key={index} className="d-flex justify-content-between">
                        <span className="text-danger">
                          <strong>{reason.rejectstatus.trim()}</strong>
                        </span>
                        <span className="text-danger">
                          {reason.rejectedAt
                            ? new Date(reason.rejectedAt).toLocaleString()
                            : "Date not available"}
                        </span>
                      </li>
                    ))}
                </ul>
              </div>
            )}

          {/* Action Buttons */}
          <div className="d-flex align-items-center justify-content-between gap-3 m-3" style={{ marginTop: "10px" }}>
  
  {/* Action Buttons */}
  {((parseInt(finalstatus, 10) === 0 ||
    parseInt(finalstatus, 10) === 2) &&
    parseInt(status, 10) === 1) && (

      <div className="d-flex gap-2">
              <>
      {allCertificatesApproved && (
        <Btn onClick={handleApprove}>Approve</Btn>
      )}
      <Btn onClick={handleReject}>Reject</Btn>
    </>
        {/* <Btn onClick={handleApprove}>Approve</Btn>
        <Btn onClick={handleReject}>Reject</Btn> */}
      </div>
  )}

  {/* Approved By */}
  <div className="d-flex align-items-center gap-2" style={{ color: "green" }}>
    <p className="fw-bold mb-0">Approved By:</p>
    <p className="mb-0">{purchaseTeamName || "Not available"}</p>
  </div>

</div>


        </Card>

        {/* Reject Reason Modal */}
        <Modal isOpen={modalOpen} backdrop="static" keyboard={false}>
          <ModalHeader toggle={() => setModalOpen(false)}>
            Reject Certificate
          </ModalHeader>
          <ModalBody>
            <label>Reason for Rejection:</label>
            <Input
              type="textarea"
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
            />
            <div className="mt-3 d-flex justify-content-end">
              <Btn onClick={submitRejection} color="danger">
                Submit
              </Btn>
            </div>
          </ModalBody>
        </Modal>


        {/* Approval Confirmation Modal */}
        <Modal isOpen={approvalModalOpen} backdrop="static" keyboard={false}>
          <ModalHeader toggle={() => setApprovalModalOpen(false)}>
            Approve Certificate
          </ModalHeader>
          <ModalBody>
            Are you sure you want to approve this medicine?
          </ModalBody>
          <div className="modal-footer">
            <Btn onClick={() => setApprovalModalOpen(false)}>Cancel</Btn>
            <Btn onClick={confirmApproval} color="primary">
              Yes, Approve
            </Btn>
          </div>
        </Modal>

      </Col>
    </>
  );
};

export default AllCertificates;